package xyz.malefic.kanman.client.pages.boards

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import kotlinx.coroutines.launch
import xyz.malefic.kanman.client.api.getPublicBoards
import xyz.malefic.kanman.client.api.joinBoard
import xyz.malefic.kanman.client.components.InfiniteBoardView
import xyz.malefic.kanman.client.components.handle

@Page
@Composable
fun Public(ctx: PageContext) {
    val scope = rememberCoroutineScope()

    InfiniteBoardView(
        "Public Boards",
        { page, limit -> getPublicBoards(page, limit) },
        { board ->
            scope.launch { handle(joinBoard(board.id)) { ctx.router.navigateTo("/boards/drive/${board.id}") } }
        },
    )
}
